export default __webpack_public_path__ + "images/af5c6c7ea0ee718b9011d504592ab9d8-social-support-network.svg";